
// This is Layout.js 
// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import SideMenu from './SideMenu';
import Header from './Header';
import './SideMenu.css';
import './Header.css'; 
import './Layout.css';


export default function Layout() {

   return (
       <div className="layout">
         <Header />
         <div className="layout-body">
           <SideMenu />
           <main className="main-content">
             <Outlet />
           </main>
         </div>
       </div>
     );


}